import React from "react";
import { Flex, Text, useColorModeValue } from "@chakra-ui/react";
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand() {
  const brandColor = useColorModeValue("brand.500", "white");
  return (
    <Flex align='center' direction='column'>
      <Text fontSize='3xl' fontWeight='bold' color={brandColor} mb='20px'>
        Alcarza
      </Text>
      <HSeparator mb='20px' />
    </Flex>
  );
}

export default SidebarBrand;
